/* src/app/auth/sso-login/sso-login.component.scss */
/*# sourceMappingURL=sso-login.component-FJYJP2BH.css.map */
